export default {
  INIT_WELCOME_TOUR: '@WS_EDITOR/INIT_WELCOME_TOUR',
  INIT_MULTILINGUAL_TOUR: '@WS_EDITOR/INIT_MULTILINGUAL_TOUR',
};
